/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BarChartOneFillIcon = /*#__PURE__*/ createSvgIcon(
  'BarChartOneFillIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path d="M6 12H2v6h4v-6z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.97 2h4.05v16h-4.05V2zm1 1v14h2.05V3h-2.05zM7.73 7.5h4.05V18H7.73V7.5zm1 1V17h2.05V8.5H8.73z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default BarChartOneFillIcon;
